<template>
  <div :class="'flags ' + type">
    <div class="flagContainer">
      <button
        v-for="(language, index) in checkLanguages"
        :key="index"
        @click="select(language.value)"
        :class="language.value"
        class="flag"
      >
        <span
          class="value"
          :class="isSelected(language.value) ? 'selected' : ''"
          >{{ language.text }}</span
        >
        <!-- <img
          :src="language.icon"
          :style="{
            filter: isSelected(language.id) ? 'none' : 'grayscale(100%)',
          }"
        /> -->
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  // https://github.com/LeCoupa/vueflags/tree/master/flags
  export default {
    name: 'Flags',

    data() {
      return {
        arrayLanguages: ['es', 'ca'],
      }
    },
    props: {
      type: {
        type: String,
        default: '',
      },
    },
    methods: {
      ...mapActions(['selectLanguage']),
      async select(id) {
        await this.selectLanguage(id)
      },
      isSelected(id) {
        if (this.languageSelected == id) {
          return true
        } else {
          return false
        }
      },
    },
    computed: {
      ...mapState(['languages', 'languageSelected']),
      checkLanguages() {
        console.log(this.arrayLanguages)
        console.log(this.languages)
        return this.languages.filter((item) =>
          this.arrayLanguages.includes(item.value)
        )
      },
    },
    watch: {
      languageSelected(to, from) {
        // this.$router.go()
        window.location.reload()
      },
    },
  }
</script>

<style scoped>
  .flags,
  .flagContainer {
    display: inline-block;
  }
  .top {
    /* float: right; */
    padding: 16px 0;
  }
  .top button:hover {
    color: #8a8a8a;
  }
  .top .selected {
    text-decoration: underline;
  }
  .side {
    padding: 10px 10px 10px 30px;
    display: block;
    font-size: 17px;
    color: #ccc;
    transition: 0.3s;
  }
  .side button {
    color: #ccc;
  }
  .side button:hover {
    color: #fff;
  }
  img {
    height: 20px;
    padding-top: 5%;
  }
  .flag {
    height: auto;
    border-width: 0;
    background-color: initial;
  }
  .value {
    font-size: 12px;
    vertical-align: middle;
  }
  .selected {
    color: #42b983;
  }
</style>
